export default "__VITE_ASSET__DiQDpdbE__"